/* EcosystemDeploymentsHistory — Historique des grappes déployées : ce que chaque
 * validation humaine a appris à NOAM, avec provenance et schéma navigable. */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Network, Loader2 } from "lucide-react";
import EcosystemGraphModal from "@/components/EcosystemGraphModal";

export default function EcosystemDeploymentsHistory() {
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/workspace/agentic/ecosystem/deployments")
      .then((r) => setItems(r.data?.items || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div className="noam-card p-5" data-testid="ecosystem-history">
      <div className="flex items-start justify-between mb-3 flex-wrap gap-2">
        <div>
          <div className="noam-overline text-[#7F77DD] inline-flex items-center gap-1.5">
            <Network className="w-3.5 h-3.5" /> Grappes déployées
          </div>
          <div className="text-sm text-zinc-300 mt-1">
            Ce que chaque conversation validée a appris à Noam : entités, relations et objets matérialisés, avec leur provenance.
          </div>
        </div>
      </div>

      {items === null ? (
        <div className="text-sm text-zinc-500 flex items-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin" /> Chargement…
        </div>
      ) : items.length === 0 ? (
        <div className="text-sm text-zinc-500 italic" data-testid="ecosystem-history-empty">
          Aucune grappe déployée pour le moment. Depuis le chat Noam, validez une proposition d'écosystème pour matérialiser vos premiers objets reliés.
        </div>
      ) : (
        <ul className="space-y-2" data-testid="ecosystem-history-list">
          {items.map((d) => (
            <li
              key={d.id}
              className="px-3 py-2.5 rounded-md border border-white/10 bg-white/[0.02] flex items-center gap-3 flex-wrap"
              data-testid={`ecosystem-history-item-${d.id}`}
            >
              <div className="flex-1 min-w-0">
                <div className="text-sm text-zinc-100 font-medium truncate">
                  {d.label || "Grappe sans titre"}
                </div>
                <div className="text-[10px] text-zinc-500">
                  {d.created_at ? new Date(d.created_at).toLocaleString("fr-CH") : ""}
                  {d.user_email ? ` · validée par ${d.user_email}` : ""}
                </div>
              </div>
              <div className="text-[10px] text-zinc-400 flex items-center gap-2 flex-wrap">
                <span className="px-1.5 py-0.5 rounded bg-[#378ADD]/10 text-[#378ADD]">
                  {d.counts.entities_created + d.counts.entities_linked} entité(s)
                </span>
                <span className="px-1.5 py-0.5 rounded bg-emerald-500/10 text-emerald-400">
                  {d.counts.items} objet(s)
                </span>
                <span className="px-1.5 py-0.5 rounded bg-[#7F77DD]/10 text-[#B4AFF0]">
                  {d.counts.relationships} relation(s)
                </span>
              </div>
              <button
                onClick={() => setOpenId(d.id)}
                className="text-[11px] px-2.5 py-1 rounded-md bg-[#7F77DD] text-white hover:bg-[#8F88E5] font-medium inline-flex items-center gap-1 shrink-0"
                data-testid={`ecosystem-history-graph-btn-${d.id}`}
              >
                <Network className="w-3 h-3" /> Voir le schéma
              </button>
            </li>
          ))}
        </ul>
      )}

      {openId && <EcosystemGraphModal deploymentId={openId} onClose={() => setOpenId(null)} />}
    </div>
  );
}
